import axios from 'axios';
import Cookie from 'js-cookie';
import { getApiUrl } from './apiUrl';

export const axiosInstance = axios.create({
  withCredentials: true
});

axiosInstance.interceptors.request.use(async config => {
  config.baseURL = getApiUrl();

  if (typeof window !== 'undefined') {
    const jwt = Cookie.get('jwt');

    if (jwt) {
      config.headers['X-Access-Token'] = jwt;
    }
  }

  return config;
}, err => Promise.reject(err));

axiosInstance.interceptors.response.use(
  response => response,
  error => Promise.reject((error.response && error.response.data) || error.message)
);
